import React, { useRef, useEffect } from 'react'
import CustomLink from '../CustomLink'
import Link from '../Link'
import ArrowIcon from '../../../static/ui/arrow-icon.inline.svg'
import { url } from '../utils'
import magicLine from '../ui/magicLine.js'
import classNames from 'classnames'
import styles from './page-navigation.module.sass'

export default function PageNavigation({ items, navOpen, setNavOpen }) {
  const menuRef = useRef(null)

  useEffect(() => {
    new magicLine(menuRef.current, styles.navLinkActive)
  }, [])

  return (
    <ul id="nav" className={styles.navList} ref={menuRef}>
      {items.map(({ link, label, info, items }, i) => (
        <li key={i} className={classNames(styles.navItem, { dropdown: items, primary: label.match('Contact') })}>
          <CustomLink
            to={link || url(label)}
            className={label.match('Contact') && !navOpen ? styles.navButton : styles.navLink}
            activeClassName={styles.navLinkActive}
            onClick={() => setNavOpen(false)}
          >
            {label}
            {label.match('Contact') && <ArrowIcon />}
            {/* {items && (
              <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.dropdownIcon}>
                <path d="M4 4L0 0H8L4 4Z" fill="currentColor" />
              </svg>
            )} */}
          </CustomLink>
          {items && (
            <>
              <button
                className={styles.dropdownTrigger}
                onClick={e => {
                  e.target.classList.toggle(styles.triggerOpen)
                  e.target.nextElementSibling.classList.toggle(styles.dropdownOpen)
                }}
              ></button>
              <div className={styles.dropdownBlock}>
                <div className={styles.blockLabel}>
                  <h2>{label}</h2>
                  <p>{info}</p>
                </div>
                <ul className={styles.dropdownList}>
                  {items.map(({ link, label, items }, i) => (
                    <li key={i} className={classNames(styles.dropdownGroup, { expand: items && items.length > 3 })}>
                      {link ? (
                        <Link
                          to={link || url(label)}
                          className={items ? styles.groupLink : styles.dropdownLink}
                          activeClassName={styles.dropdownLinkActive}
                          onClick={() => setNavOpen(false)}
                        >
                          {label}
                        </Link>
                      ) : (
                        <b className={items ? styles.groupLink : styles.dropdownLink}>{label}</b>
                      )}
                      {items && (
                        <ul>
                          {items.map(({ link, label }, i) => (
                            <li key={i} className={classNames(styles.dropdownItem)}>
                              <Link
                                to={link || url(label)}
                                className={styles.dropdownLink}
                                activeClassName={styles.dropdownLinkActive}
                                onClick={() => setNavOpen(false)}
                              >
                                {label}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </>
          )}
        </li>
      ))}
    </ul>
  )
}
